import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import { CurrentPlan } from "./Dental/CurrentPlan";
import { PhoneLink } from "../common/PhoneLink";
import { EmailLink } from "../common/EmailLink";
import * as FileSaver from 'file-saver';

/**
 * Container component for the Dental page.
 * 
 */

const description = () => {
    return <div className="description">Dental insurance is provided by Metlife. <b>Metlife Dental</b> is backed by the commitment, knowledge and strength you need to deliver a quality dental benefits plan that satisfies your needs.</div>;
}
const contactMetLife = () => {
    return <div className="contact-metlife">
        <div className="hp-title"> Contact MetLife </div>
        <PhoneLink phoneNumber="800.942.0854" />
        <PhoneLink phoneNumber="859.389.6505" />
        <EmailLink emailAddress="dentalinfo@metlife.com" />
        <br />
        <div className="section-subtitle dental-subtitle">Individual HMO Plan Members</div>
        <div> Qualified Health Plans</div>
        <PhoneLink phoneNumber="800.275.4638" />
        <div> Member ID Number is Policyholder's Social Security Number or 9 digit contract number</div>
        <br />
        <div className="section-subtitle dental-subtitle">FAQ - Freqently Asked Questions</div>
        <div>Q: Where can I view network providers?</div>
        <div>A: Contact Metlife </div>
    </div>;
}
const metLifeImage = () => {
    return <a tabIndex="0" className="metlife-image-link" href="https://www.metlife.com/insurance/dental-insurance/">
        <img alt="Smile. Check out Metlife. Click Here" className="metlife-image" src="../../../images/metlife-dental-web-banner.png" width="307px" height="178px" />
    </a>;
}

class Dental extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            memberId: this.props.swhp,
            invoiceDetails: null
        };
    }

    componentDidMount = () => {
        this.props.getDentalInvoiceDetails(this.state.memberId);
        this.props.getMembersList();
    }

    componentDidUpdate = (prevProps) => {

        if (prevProps.dentalInvoice !== this.props.dentalInvoice) {
            this.setState({ invoiceDetails: this.props.dentalInvoice });
        }

        if ((this.props.invoicePDF !== prevProps.invoicePDF)) {
            this.handleInvoiceDownload();
        }
    }

    handleInvoiceDownload() {
        if (this.props.error || !this.props.invoicePDF || this.props.invoicePDF === undefined || this.props.invoicePDF.status === 204) {
            //TODO - revisit this... 
            if (this.props.error) {
                switch (this.props.error.status) {
                    case 404:
                        alert("This particular invoice is not available at this time. Please check back later.");
                        return;
                    default:
                        alert("Unable to download document at this time.");
                        return;
                }
            }
        }
        else {
            FileSaver.saveAs(this.props.invoicePDF, this.props.invoicePDFName);
        }
    }

    goToInvoicesDetailsForLatestInvoice = () => {
        let invoiceNumber = this.props.dentalInvoice ? this.props.dentalInvoice.LatestInvoiceNumber : 0;
        let contractNumber = this.props.dentalInvoice ? this.props.dentalInvoice.ContractNumber : 0;
        this.props.getInvoicesPDF(contractNumber, invoiceNumber);
        //this.props.history.push("/invoiceDetails", { invoiceId: invoiceNumber });
    }
    renderCurrentPlan = () => {
        if (this.props.error && this.props.error === "Member Has No Dental Contract") {
            return <div>
                <div className="error">Member Has No Dental Contract</div>
                <hr />
            </div>;
        }
        if (!this.state.invoiceDetails || !this.props.membersList) {
            return <div id="usage-member-info-spinner" className="spinner">
                <div className="bounce1" />
                <div className="bounce2" />
                <div className="bounce3" />
            </div>;
        }
        let member = this.props.membersList.find(m => { return m.RelationshipToSubscriber === "SELF" });
        return <CurrentPlan
            currentPlanEffectiveDate={member.EffectiveDate}
            dentalInvoice={this.state.invoiceDetails}
            invoiceDownloadFunction={this.goToInvoicesDetailsForLatestInvoice}
            payOnlineFunction={() => { this.props.ssoInvoicesandPayments(this.state.invoiceDetails.ContractNumber) }} />;
    }
    render = () => {
        return (
            <div className="container-fluid body-content hp">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="hp-title ">
                            Dental Plan
                        </div>
                    </div>
                    <hr className="full-width"></hr>
                    <div className="col-12 maxWidth-content">
                        <div className="dental-wrapper">
                            <div className="dental-container">
                                <div>
                                    {this.renderCurrentPlan()}
                                </div>
                            </div>
                            <div>
                                {description()}
                                {metLifeImage()}
                                {contactMetLife()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

const mapStateToProps = (state, ownProps) => {
    return {
        isFetching: state.healthPlanServices.isFetching,
        hpIdentity: state.session.healthPlanUserProfile,
        swhp: state.domain.hi,
        error: state.healthPlanServices.error,
        swhp: state.domain.hi, currentMemberId: state.healthPlanServices.currentMemberId,
        membersList: state.healthPlanServices.membersList,
        invoicePDF: state.healthPlanServices.invoicePDF,
        invoicePDFName: state.healthPlanServices.invoicePDFName,
        dentalInvoice: state.healthPlanServices.dentalInvoiceDetails, /***/

        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getInvoicesPDF: (MemberId, InvoiceNumber) => dispatch({ type: types.HP_GET_INVOICE_PDF_START, MemberId: MemberId, InvoiceNumber: InvoiceNumber }),
        getMembersList: () => dispatch({ type: types.HP_GET_MEMBERS_LIST_START }),
        ssoInvoicesandPayments: (ContractNo) => dispatch({ type: types.HP_SSO_INVOICESANDPAYMENTS_START, contractNumber: ContractNo }),
        getDentalInvoiceDetails: (MemberId) => dispatch({ type: types.HP_GET_DENTAL_INVOICE_DETAIL_START, memberId: MemberId })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dental))